export class StorageKeys {
    public static readonly USER = 'USER';
    public static readonly TAN = 'TAN';
}
